module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/rewards/requisition-elite-reward-50.0c1b5162.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/rewards/requisition-elite-reward-50.png
// module id = 3795
// module chunks = 11